module.exports = __webpack_public_path__ + "media/images/athletes/27-282931a77a65fbed32483cfe4139946e.png";